import { setNavigation } from "../Slice/ReduxSlice/CommonSlice.js/NavigationSlice";
import { setToastMessage } from "../Slice/ReduxSlice/CommonSlice.js/toastSlice";


export const errorHandler = ({
  err,
  errMessage,
  handleLoader,
  specific,
  dispatch,
}) => {
  const alertError = (message) => {
    dispatch(
      setToastMessage({
        message: specific ? message : errMessage || message,
        type: "error",
      })
    );
  };

  if (err?.status === 403) {
    dispatch(setNavigation("noServicePage"));
  } else if (err?.status === 401) {
    alertError(
      specific ? errMessage : err?.data?.error || "Unauthorized access"
    );
  } else if (err?.status === 400) {
    alertError(specific ? errMessage : err?.data?.error || "Bad request");
    dispatch(setNavigation("homePage"));
  } else if (err?.status === 404) {
    alertError(specific ? errMessage : err?.data?.error || "No area found");
  } else if (err?.status === 503) {
    alertError(
      specific
        ? errMessage
        : err?.data?.error || "Service is temporarily unavailable"
    );
  } else if (err?.status === 429) {
    alertError(
      specific
        ? errMessage
        : err?.data?.error
    );
  } else {
    alertError("Oops, something went wrong!");
  }

  handleLoader && handleLoader();
};
